import { ActivityListField, type BodyRowConfig } from '@ztechapps/webui.data-tools'
import type { RouteDef, Project } from '@ztechapps/common.contract'
import { LocalDate } from '@ztechapps/webui.date'
import { Link } from 'react-router-dom'
import { DurationDisplayContent, Tags } from '@ztechapps/webui.input'
import React from 'react'
import { useInject, WebuiIocKey } from '@ztechapps/webui.contract'
import { ProjectStatusWithProgress } from '../project-status/ProjectStatusWithProgress'
import { useFormatWorkdayTime } from '@ztechapps/common.hook'

const CodeColumn = (props: BodyRowConfig<Project>) => {
  const projectItemRoute = useInject<RouteDef>(WebuiIocKey.routes.projectItem)

  const { code, _id } = props
  return (
    <Link to={projectItemRoute.altPath({ _id })}>
      <b>{code}</b>
    </Link>
  )
}

const TimeSpentColumn = (props: BodyRowConfig<Project>) => {
  const { timeSpent } = props
  const { workdayConfig } = useFormatWorkdayTime()
  return <DurationDisplayContent value={timeSpent} workdayConfig={workdayConfig} />
}

const StatusColumn = (props: BodyRowConfig<Project>) => {
  const { status, progressNow, progressMax } = props
  return <ProjectStatusWithProgress status={status} progressMax={progressMax} progressNow={progressNow} />
}

export const DataListRow = (props: BodyRowConfig<Project>) => {
  const { createdAt, completionDate, tags, remarks, remarksActivity } = props

  return (
    <>
      {props._renderDataBodyCell({
        status: <StatusColumn {...props} />,
        code: <CodeColumn {...props} />,
        tags: <Tags dataArray={tags} />,
        remarks: <ActivityListField remarks={remarks} remarksActivity={remarksActivity} />,
        createdAt: <LocalDate value={createdAt} />,
        completionDate: <LocalDate value={completionDate} />,
        timeSpent: <TimeSpentColumn {...props} />,
      })}
    </>
  )
}
